import React, { Component } from 'react';

class Index extends Component {
    render() {
        const { estados } = this.props;

        return (
            <React.Fragment>
                {this.props.data.length >= 1 ? (
                    this.props.data.map(proceso => {
                        const documents = (proceso.general_files || []).length;

                        return (
                            <div className="rk-info" key={proceso.id}>
                                <div className="rk-info-grid">
                                    <div className="rk-info-field">
                                        <div className="rk-info-field__label">Proceso</div>
                                        <div className="rk-info-field__value">{proceso.name}</div>
                                    </div>

                                    <div className="rk-info-field">
                                        <div className="rk-info-field__label">Prefijo</div>
                                        <div className="rk-info-field__value"><span className="rk-chip">{proceso.prefix}</span></div>
                                    </div>

                                    <div className="rk-info-field">
                                        <div className="rk-info-field__label">Tipo de proceso</div>
                                        <div className="rk-info-field__value">{proceso.proceso_type}</div>
                                    </div>

                                    <div className="rk-info-field">
                                        <div className="rk-info-field__label">Descripción</div>
                                        <div className="rk-info-field__value">{proceso.description ? proceso.description : "—"}</div>
                                    </div>
                                </div>

                                <div className="rk-toolbar" style={{ margin: "16px 0 0", flexWrap: "wrap" }}>
                                    <button type="button" className="rk-link-btn" onClick={() => this.props.openDocuments(proceso)}>
                                        <i className="fas fa-folder-open"></i> Documentos
                                        <span className={`rk-count ${documents == 0 ? "rk-count--zero" : ""}`}>{documents}</span>
                                    </button>

                                    <span className="rk-inline-actions" style={{ marginLeft: "auto" }}>
                                        {estados.editar && (
                                            <button type="button" className="rk-icon-btn" onClick={() => this.props.edit(proceso)} title="Editar">
                                                <i className="fas fa-pencil-alt"></i>
                                            </button>
                                        )}

                                        {estados.eliminar && (
                                            <button type="button" className="rk-icon-btn rk-icon-btn--cancel" onClick={() => this.props.delete(proceso.id)} title="Eliminar">
                                                <i className="fas fa-trash-alt"></i>
                                            </button>
                                        )}
                                    </span>
                                </div>
                            </div>
                        );
                    })
                ) : (
                    <div className="rk-table-card">
                        <div className="rk-empty">
                            <i className="fas fa-project-diagram"></i>
                            <p>No hay registros</p>
                        </div>
                    </div>
                )}
            </React.Fragment>
        );
    }
}

export default Index;
